import actionTypes from './actionTypes';

export const sidebarToggle = (payload: boolean) => ({
    type: actionTypes.SIDEBAR_TOGGLE,
    payload
});

export const setViewMode = () => ({
    type: actionTypes.SET_VIEW_MODE
});
